'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import {SlideDown} from 'react-slidedown'

// import ReactPlayer from 'react-player'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactScroll = require('react-scroll');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _HowItWorks = require('./HowItWorks.css');

var _HowItWorks2 = _interopRequireDefault(_HowItWorks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorks = (_dec = (0, _reactCssModules2.default)(_HowItWorks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HowItWorks, _Component);

  function HowItWorks() {
    (0, _classCallCheck3.default)(this, HowItWorks);
    return (0, _possibleConstructorReturn3.default)(this, (HowItWorks.__proto__ || (0, _getPrototypeOf2.default)(HowItWorks)).apply(this, arguments));
  }

  (0, _createClass3.default)(HowItWorks, [{
    key: 'render',
    value: function render() {
      var title = 'How it works';
      var description = 'Get your money out of fossil fuels. Fossil Free Funds tracks thousands of mutual funds commonly found in retirement plans.';
      var url = _config2.default.domain + _config2.default.routes.howitworks;

      var sriIcon = require('../../../static/images/sri.png');
      var ussifIcon = require('../../../static/images/ussif-logo.png');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page', id: 'top' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'title-nav-row' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 8, styleName: 'title-nav-title' },
              _react2.default.createElement(
                'h1',
                { styleName: 'title' },
                'How it works'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'subtitle' },
                'Getting started, methodology, and fossil fuel company lists'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'lede' },
                'Fossil Free Funds sources financial data from Morningstar, an investment research company. We use Morningstar\u2019s mutual fund and stock data to analyze funds and find investments in fossil fuel companies. Our database covers thousands of the most popular mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.'
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 4, styleName: 'title-nav-nav' },
              _react2.default.createElement(
                'nav',
                { styleName: 'page-nav' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'page-nav-title' },
                  'Contents'
                ),
                [['Getting started', 'getting-started'], ['Fossil fuel companies', 'companies'], ['Mutual fund grades', 'fossil-fuel-grades'],
                // ['Fund managers','fund-manager-ratings'],
                ['Spreadsheet', 'spreadsheet']].map(function (e, i) {
                  return _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      key: 'nav-scroll-link-' + i,
                      to: e[1],
                      spy: true,
                      smooth: true,
                      duration: 500,
                      title: e[0]
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'page-nav-btn' },
                      e[0]
                    )
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'getting-started' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Getting started'
            ),
            _react2.default.createElement(
              _components.Link,
              { to: _config2.default.routes.videoTutorials, title: 'Video tutorials' },
              _react2.default.createElement(
                'div',
                { styleName: 'bn-flex' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'bn-copy' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'bn-title' },
                    'Video tutorials'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'bn-lede' },
                    'Watch our video tutorials to learn the basics of Fossil Free Funds.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'bn-button' },
                    'Watch now',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ),
                _react2.default.createElement('div', { styleName: 'bn-img', title: 'Video tutorials' })
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Finding your funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'We source data on companies and mutual funds from financial services provider Morningstar. Our database covers thousands of U.S. open-end mutual funds and exchange-traded funds (ETFs), some of the most common funds held in 401(k)s, 403(b)s, and other retirement plans.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Search for funds by name, ticker, or asset manager. Use the search bar below, or ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    title: 'Search funds',
                    xstrong: true
                  },
                  'use the search page'
                ),
                ' to do more advanced searches, such as filtering funds by investing style or asset manager. When you find a fund you\'re looking for, click it to see the full results.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'search-bar-wrap' },
                _react2.default.createElement(_components.AutocompleteSearch, null)
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                'We don\'t have everything in our database \u2014 we only analyze U.S. mutual funds and ETFs that are at least 50% invested in stock holdings, and our data license restricts us to displaying only a few thousand portfolios.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Looking for your favorite fund and can\u2019t find it? With more resources, we could include more funds \u2014 ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.donate,
                    title: 'Donate to As You Sow',
                    xstrong: true
                  },
                  'make a gift today to make a difference.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-title' },
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                  '\xA0',
                  _react2.default.createElement(
                    'em',
                    null,
                    'Our research universe'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Our database covers open-end mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don\u2019t have data on funds domiciled outside the U.S. The fund ratings are based on tracking stock investments in publicly-traded companies. Currently, we don\u2019t have ratings for fixed income funds. We exclude funds with less than 50% of fund assets in equity holdings from the analysis universe.'
                  )
                )
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null)
          ),
          _react2.default.createElement(_components.FossilFuelCompaniesContent, null),
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'fossil-fuel-grades' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Mutual fund grades'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Calculating exposure to fossil fuel companies'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. For each fund, we calculate the total number, dollar amount, and percentage of the fund\u2019s assets that are invested in those companies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We only look for direct stock holdings in fossil fuel companies. That means that holdings that are not stocks, like cash holdings or bonds, are not rated. In the fund\'s investment profile, we show a "Percent Rated" metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund\u2019s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden fossil fuel-related investments that our tool cannot account for, in the form of bond holdings or other asset types.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-title' },
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                  '\xA0',
                  _react2.default.createElement(
                    'em',
                    null,
                    'Measuring long holdings only'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                    _react2.default.createElement(
                      'em',
                      null,
                      'holding market value divided by the sum of the market value for all long holdings in the portfolio.'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Banks and insurance: fossil fuel financial services'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Fossil Free Funds now incorporates fossil finance into our fossil fuel ratings.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'By continuing to finance and underwrite fossil fuels, banks and insurance companies are not only responsible for exacerbating climate impacts, but they are also exposing investors to financial risk.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Our new fund ratings use data on bank lending and insurance company policies to assess portfolio exposure to finance-industry climate risk.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.banksInsurance,
                    title: 'Fossil fuel lending & insurance',
                    xstrong: true
                  },
                  'Learn more about our new fossil fuel finance and fossil fuel insurance ratings',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Fossil fuel grades'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Based on the fund\'s fossil fuel exposure, it earns one of five grades.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullets' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 1 }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'No holdings flagged for our fossil fuel screens. Assigned a grade of A.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 2 }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fossil fuel exposure between 0% and 3%; OR, fossil fuel exposure is 0%, but fossil fuel finance and insurance exposure is above 0%. Assigned a grade of B.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 3 }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fossil fuel exposure between 3% and 5.5%; OR, fossil fuel exposure below 3%, with investments in ',
                    _react2.default.createElement(
                      'b',
                      null,
                      'higher risk'
                    ),
                    ' companies (top carbon reserve owners and/or top coal-fired utilities). Assigned a grade of C.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 4 }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fossil fuel exposure between 5.5% and 9%. Assigned a grade of D.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 5 }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fossil fuel exposure between 9% and 100%. Assigned a grade of F.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Details on fossil fuel exposure'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Along with the fossil fuel grade, we show details on the fund portfolio\'s flagged holdings.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The number of flagged holdings, the amount invested by the fund, and the percent of the fund\'s portfolio those holdings make up are shown. The same figures are available for the various sub-categories, and for each individual flagged holding.'
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Carbon footprint'
            ),
            _react2.default.createElement(_components.FootprintDeprecated, null),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'A fund\'s carbon footprint is based on the annual GHG emissions of each company invested in by fund. To independently analyze and calculate carbon footprints for the mutual funds, we used the powerful ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.carbonfootprint,
                    xstrong: true,
                    title: 'Carbon footprint'
                  },
                  '"Carbon Footprint Analysis Tool" of yourSRI.com,'
                ),
                ' which provides the data on corporate emissions worldwide - comprised of more than 40,000 companies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We show two key metrics related to carbon emissions - the fund\'s relative carbon footprint, and the relative carbon intensity. The carbon footprint is based on amount of emissions per unit of ',
                _react2.default.createElement(
                  'i',
                  null,
                  'investment'
                ),
                ', while the intensity is based on amount of emissions per unit of ',
                _react2.default.createElement(
                  'i',
                  null,
                  'revenue'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For these two metrics, we compare the fund\'s results to a slate of 20 benchmarks from major index providers like MSCI, FTSE/Russell, S&P, and Morningstar. Using iShares ETFs as a stand-in for each index, we calculate the carbon footprint and divide the benchmarks into quartiles, labeled:'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'low' },
                  'Low',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-circle' })
                ),
                ' \u2014 Fund footprint/intensity is within the range of the bottom 25% of benchmarks'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'avg' },
                  'Below median',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-circle' })
                ),
                ' \u2014 Fund footprint/intensity is within the range of the second 25% of benchmarks'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'high' },
                  'Above median',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-circle' })
                ),
                ' \u2014 Fund footprint/intensity is within the range of the third 25% of benchmarks'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'very-high' },
                  'High',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-circle' })
                ),
                ' \u2014 Fund footprint/intensity is within the range of the top 25% of benchmarks'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'extreme' },
                  'Very high',
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-circle' })
                ),
                ' \u2014 Fund footprint/intensity is higher than all 20 benchmarks'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We recalculate the benchmark quartiles each month based on their corresponding iShares ETFs.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We also show the emissions weight of the top 10 holdings in the fund. If a holding\'s emissions weight is higher than its portfolio weight, it means the holding is responsible for an outsized amount of the fund\'s carbon footprint.'
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Sustainable funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement('img', {
                styleName: 'sri',
                src: sriIcon,
                alt: 'Sustainably-mandated  fund',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'sri-icons-tooltip',
                'data-place': 'bottom',
                'data-tip': '<div style=\'max-width:200px;\'>Designated a sustainably-mandated fund by Morningstar. Sustainably-mandated funds consider issues like the environment and human rights.</div>'
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'sri-icons-tooltip' }),
              _react2.default.createElement(
                'p',
                null,
                'We use Morningstar\'s "sustainability mandate" indicator to determine which funds are displayed as sustainably-mandated. Sustainably-mandated funds make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainably-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated sustainably-mandated.'
              ),
              _react2.default.createElement('img', {
                styleName: 'ussif',
                src: ussifIcon,
                alt: 'Member of US-SIF, the Forum for Sustainable and Responsible Investment',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'ussif-icons-tooltip',
                'data-place': 'bottom',
                'data-tip': '<div style=\'max-width:200px;\'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>'
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'ussif-icons-tooltip' }),
              _react2.default.createElement(
                'p',
                null,
                'The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of weapons. Look for this symbol to find funds that are members of US-SIF.'
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Fossil free action toolkit'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'When you\'re done looking up funds and finding the data you need, what\'s next? You can learn how to make a change and move your money with our ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.toolkit, xstrong: true, title: 'Fossil free action toolkit' },
                  'fossil free action toolkit'
                ),
                '. Whether you\u2019re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There\'s an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more \u2014 everything you need to make a change and get started investing your money fossil free.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null)
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'spreadsheet' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Spreadsheet'
            ),
            _react2.default.createElement(_components.Changelog, null),
            _react2.default.createElement(_components.ScrollToTop, null)
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return HowItWorks;
}(_react.Component)) || _class);
exports.default = HowItWorks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HowItWorks/HowItWorks.js
// module id = 1409
// module chunks = 0